import React, { useState, useEffect } from "react";
import { Form, Input, Table, Image, Space, Button, Modal, Radio } from "antd";
import baseRequest from "../../utils/baseRequest";

const ManualRechargeAndWithdrawalContent = (props) => {
  const { TextArea } = Input;
  //表头
  const columns = [
    {
      title: "新内容",
      dataIndex: "newMedia",
      key: "newMedia",
      render: (data) => (
        <div className="flex flex-wrap gap-1">
          {data?.map((item, index) => (
            <Image key={index} src={item.urls[0]} width={100} />
          ))}
        </div>
      ),
    },
    {
      title: "旧内容",
      dataIndex: "oldMedia",
      key: "oldMedia",
      render: (data) => (
        <div className="flex flex-wrap gap-1">
          {data?.map((item, index) => (
            <Image key={index} src={item.urls[0]} width={100} />
          ))}
        </div>
      ),
    },
    {
      title: "审核结果",
      dataIndex: "info",
      key: "info",
    },
    {
      title: "提交时间",
      dataIndex: "submitTime",
      key: "submitTime",
    },
    {
      title: "备注",
      dataIndex: "remarks",
      key: "remarks",
      render: (_, record) => (
        <Form.Item name={record.id} initialValue={record.remarks}>
          <TextArea disabled rows={4} />
        </Form.Item>
      ),
    },
  ];
  //获取数据
  const [data, setData] = useState([]);
  //   const [offset, setOffset] = useState(0);
  //   const [more, setMore] = useState(1);
  //   const getData = async () => {
  //     if (!more) return;
  //     try {
  //       const base = baseRequest();
  //       const response = await fetch("/op/image_audit_task/list", {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify({
  //           offset: offset,
  //           limit: 20,
  //           ...base,
  //         }),
  //       });
  //       const temData = await response.json();
  //       if (temData.ret === -1) {
  //         alert(temData.msg);
  //         return;
  //       }
  //       //匹配表格格式
  //       const structedData = temData.data.list.map((item, index) => {
  //         return {
  //           key: index,
  //           id: item.id,
  //           newMedia: item?.audited_media?.images,
  //           oldMedia: item?.old_media?.images,
  //           info: item.image_audits,
  //           submitTime: new Date(item.ct * 1000).toLocaleString(),
  //           remarks: item.remarks,
  //           others: {
  //             id: item.id,
  //             audited_media: item.audited_media,
  //             associative_database: item.associative_database,
  //             associative_table_name: item.associative_table_name,
  //             associative_table_id: item.associative_table_id,
  //             associative_table_column: item.associative_table_column,
  //           },
  //         };
  //       });
  //       setData([...data, ...structedData]);
  //       setOffset(temData.data.offset);
  //       setMore(temData.data.more);
  //     } catch (error) {
  //       console.error(error);
  //     }
  //   };
  //   useEffect(() => {
  //     getData();
  //   }, []);

  //展示的数据
  const [showData, setShowData] = useState([]);
  useEffect(() => {
    setShowData(data);
  }, [data]);
  //搜索
  const search = (value) => {
    value.name || value.mid
      ? setShowData(
          data.filter(
            (item) => item.userId === value.userId || item.name === value.name
          )
        )
      : setShowData(data);
  };
  //表单提交失败
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  //控制充值modal是否出现
  const [isModalOpen, setIsModalOpen] = useState(false);
  //在modal中搜索用户
  const [userInfo, setUserInfo] = useState();
  const modalSearch = async (value) => {
    try {
      const base = baseRequest();
      const response = await fetch(`/op/account/list_by_user_id`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          user_id: parseInt(value.userId, 10),
          ...base,
        }),
      });
      const data = await response.json();
      console.log(data);
      if (data.ret === -1) {
        alert(data.msg);
        return;
      }
      setSelectedUser();
      setUserInfo(data.data.account);
    } catch (error) {
      console.error(error);
    }
  };
  //选中用户
  const [selectedUser, setSelectedUser] = useState();
  const handleSelected = () => {
    if (selectedUser) {
      setSelectedUser();
      return;
    }
    setSelectedUser(userInfo.mid);
  };
  //提交修改
  const [form] = Form.useForm();
  const handleSubmit = async (value) => {
    if (!selectedUser) {
      alert("还未选中用户");
      return;
    }

    try {
      const base = baseRequest();
      const response = await fetch(`/op/vas/create_order`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          mid: selectedUser,
          coins: parseInt(value.num, 10),
          operator: value.password,
          ...base,
        }),
      });
      const data = await response.json();
      if (data.ret === -1) {
        alert(data.msg);
        return;
      }
    } catch (error) {
      console.error(error);
    }

    form.resetFields();
    setUserInfo();
    setSelectedUser();
    setIsModalOpen(false);
  };
  //关闭弹窗
  const handleCancelModal = () => {
    form.resetFields();
    setUserInfo();
    setSelectedUser();
    setIsModalOpen(false);
  };

  return (
    <div className="mt-4" style={{ marginLeft: 20, marginRight: 20 }}>
      <Form name="search" onFinish={search} onFinishFailed={onFinishFailed}>
        <Space style={{ marginBottom: 20 }}>
          <Form.Item label="ID" name="userId" style={{ margin: 0 }}>
            <Input type="number" />
          </Form.Item>
          <Form.Item label="昵称" name="name" style={{ margin: 0 }}>
            <Input />
          </Form.Item>
          <Button type="primary" htmlType="submit">
            搜索
          </Button>
        </Space>
      </Form>
      <Button
        className="mb-4"
        type="primary"
        onClick={() => setIsModalOpen(true)}
      >
        人工操作
      </Button>
      <Form name="remarks">
        <Table
          columns={columns}
          dataSource={showData}
          pagination={{ pageSize: 20 }}
          scroll={{ y: window.innerHeight - 300 }}
        />
      </Form>
      <Modal footer={null} open={isModalOpen} onCancel={handleCancelModal}>
        <p className="text-sm text-red-400 font-bold">
          *金币、钻石涉及现金，请谨慎确认
        </p>
        <Form name="modal_search" onFinish={modalSearch}>
          <Space style={{ marginBottom: 20 }}>
            <Form.Item label="ID" name="userId" style={{ margin: 0 }}>
              <Input type="number" />
            </Form.Item>
            <Button type="primary" htmlType="submit">
              搜索
            </Button>
          </Space>
        </Form>
        {userInfo && (
          <div
            className={`flex flex-row items-center p-2 rounded-xl ${
              selectedUser ? "bg-green-300" : "bg-gray-300"
            }`}
          >
            <Image
              src={userInfo?.avatar?.images[0].urls[0]}
              width={80}
              height={80}
            />
            <div className="flex flex-col justify-center mx-4">
              <p className="text-lg font-bold">ID：{userInfo.user_id}</p>
              <p className="text-lg font-bold">昵称：{userInfo.name}</p>
            </div>
            <Button
              type={selectedUser ? "default" : "primary"}
              onClick={handleSelected}
            >
              {selectedUser ? "取消选中" : "选中用户"}
            </Button>
          </div>
        )}
        <Form
          className="mt-4 flex flex-col"
          form={form}
          onFinish={handleSubmit}
        >
          <Space>
            <Form.Item
              label=""
              name="type"
              rules={[
                {
                  required: true,
                  message: "未选择",
                },
              ]}
              style={{ margin: 0 }}
            >
              <Radio.Group>
                <Radio.Button value="+">增加</Radio.Button>
                {/* <Radio.Button value="-">减少</Radio.Button> */}
              </Radio.Group>
            </Form.Item>
            <Form.Item
              label=""
              name="item"
              rules={[
                {
                  required: true,
                  message: "未选择",
                },
              ]}
              style={{ margin: 0 }}
            >
              <Radio.Group>
                <Radio.Button value="gold">金币</Radio.Button>
                {/* <Radio.Button value="diamond">钻石</Radio.Button> */}
              </Radio.Group>
            </Form.Item>
          </Space>
          <div className="mt-4 flex flex-row items-center">
            <Form.Item
              label="数量"
              name="num"
              rules={[
                {
                  required: true,
                  message: "未填写",
                },
              ]}
              style={{ margin: 0 }}
            >
              <Input className="w-32" type="number" min={0} max={10000} />
            </Form.Item>
            <Form.Item
              label="支付密码"
              name="password"
              rules={[
                {
                  required: true,
                  message: "未填写",
                },
              ]}
              style={{ margin: 0 }}
            >
              <Input className="w-32" type="password" min={0} max={10000} />
            </Form.Item>
            <Button className="ml-8" type="primary" htmlType="submit">
              确认
            </Button>
          </div>
        </Form>
      </Modal>
    </div>
  );
};

export default function ManualRechargeAndWithdrawal() {
  return <ManualRechargeAndWithdrawalContent />;
}
